export default __webpack_public_path__ + "static/accent-resume-6bd013633937f3e3c89605cd7ad986dc.png";